import React from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import AddressControl from '../../form/AddressControl';
import createForm from "./Form";
import UserControl from "../../form/partner/user";

class userForm extends React.Component {

    render() {
        return (
            <form onSubmit={ this.props.handleSubmit }>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <TextInput name={this.props.componentConfig.idfield} value={ this.props.values[this.props.componentConfig.idfield] } label="Kód" role="idfield"/>
                    </div>
                    <div className="col-sm-4 col-sm-pull-4">
                        <UserControl value={this.props.values} fields={{"lastname": {parent: true}}} saveChanges={ this.props.setFieldValue } />
                    </div>
                    <div className="col-sm-4 col-sm-pull-4">
                        <UserControl value={this.props.values} fields={{"firstname": {parent: true}}} saveChanges={ this.props.setFieldValue } />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-6">
                        <UserControl value={this.props.values} fields={{"telnum": {parent: true}}} saveChanges={ this.props.setFieldValue } />
                    </div>
                    <div className="col-md-6">
                        <UserControl value={this.props.values} fields={{"email": {parent: true}}} saveChanges={ this.props.setFieldValue } />
                    </div>
                </div>
                <div className="row form-row">
                    <AddressControl value={this.props.values.address} label="Cím"
                                    saveChanges={this.props.setFieldValue}/>
                </div>
                <div className="row form-row">
                    <div className="col-md-6">
                        <Select component="Group" storeType="remote" labelKey="name" objectValue={true} isMulti={true} name="groups" value={ this.props.values.groups || [] } label="Csoportok" saveChanges={ this.props.setFieldValue } />
                    </div>
                    <div className="col-md-6">
                        <Select
                            label="Partner"
                            name="partner"
                            component="partner"
                            objectValue={true}
                            isClearable={true}
                            labelKey="name"
                            valueKey="partner_id"
                            storeType="remote"
                            value={this.props.values.partner}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(userForm);
